import { Navigate, Route, Routes } from 'react-router-dom';
import Home from '../Pages/Home';
import Login from '../Pages/Login';
import { Instances } from '../Pages/Instances';
import Playground from '../Pages/Playground';
import NewIntro from '../Pages/NewIntro';
import Layout from '../Layout';
import MultitoolSoftware from '../Pages/InstancesList';
import TermsAndConditions from '../UI/FooterPages/Termsandconditions';
import Privacy from '../UI/FooterPages/Privacy';
import Cancellation from '../UI/FooterPages/Cancellation';

const AppRoutes = ({ jwt }) => {
  const isAuthenticated = jwt && jwt !== 'null';

  return (
    <Routes>
      {/* Catch-all */}
      <Route path="*" element={<Navigate to={isAuthenticated ? '/home' : '/intro'} />} />
      <Route path="/" element={<Navigate to={isAuthenticated ? '/home' : '/intro'} />} />

      {/* Public routes */}
      <Route path="/login" element={isAuthenticated ? <Navigate to="/home" /> : <Login />} />
      <Route
        path="/intro"
        element={isAuthenticated ? <Navigate to="/home" /> : <NewIntro />}
      />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/refund-policy" element={<Cancellation />} />
   

      {/* Protected routes */}
      {isAuthenticated && (
        <>
          <Route element={<Layout />}>
            <Route path="/home" element={<Home />} />
            <Route path="/myapplications" element={<Instances />} />
            <Route path="/playground" element={<Playground />} />
            <Route path="/instances" element={<MultitoolSoftware />} />
          </Route>
        </>
      )}

    </Routes>
  );
};

export default AppRoutes;